import {PluginFunction} from 'vue';

import { Orientation } from '../enums/Orientation';
import { AmenityType } from '../enums/AmenityType';
import { ApartmentFeature } from '../enums/ApartmentFeature';
import { ApartmentType } from '../enums/ApartmentType';
import { ApartmentSearchSortType } from '../enums/ApartmentSearchSortType';
import { ApartmentSearchSortDirection } from '../enums/ApartmentSearchSortDirection';
import { InstanceType } from '../enums/InstanceType';
import { Language } from '@/enums/Language';
import { getEnumKeys, getEnumValues } from '../helpers/enums';
import { CGReservationStatus } from '../enums/CGReservationStatus';
import { FakeSaleStatus } from '../enums/FakeSaleStatus';
import { OfferStatus } from '../enums/OfferStatus';
import { SaleStatus } from '../enums/SaleStatus';
import { SaleStatusForWeb } from '../enums/SaleStatusForWeb';
import { ApartmentPriceTableColumn } from '../enums/ApartmentPriceTableColumn';
import { EquipmentSelectionType } from '../enums/EquipmentSelectionType';
import { FloorAbbrForTooltip } from '../enums/FloorAbbrForTooltip';

export const Enums: PluginFunction<never> = (Vue) => {
	/* Make enums accessible from templates */
	Vue.prototype.enums = {
		AmenityType: AmenityType,
		ApartmentFeature,
		ApartmentPriceTableColumn,
		ApartmentType,
		ApartmentSearchSortType,
		ApartmentSearchSortDirection,
		CGReservationStatus,
		EquipmentSelectionType,
		FakeSaleStatus,
		InstanceType,
		Language,
		OfferStatus,
		Orientation,
		SaleStatus,
		SaleStatusForWeb,
		FloorAbbrForTooltip
	}

	Vue.mixin({
		methods: {
			getEnumKeys,
			getEnumValues
		}
	})
}

declare module "vue/types/vue" {
	interface Vue {
		getEnumKeys: typeof getEnumKeys,
		getEnumValues: typeof getEnumValues
	}
}
